import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { CONTACT_EMAIL, WHATSAPP_DISPLAY } from "@/lib/api";
import { LEGAL } from "@/pages/legalContent";

export default function Legal({ kind }: { kind: "privacy" | "terms" }) {
  const { lang } = useLang();
  const { hash } = useLocation();
  const doc = LEGAL[kind][lang];
  useEffect(() => {
    if (hash) { const id = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 150); return () => clearTimeout(id); }
    window.scrollTo(0, 0);
  }, [hash, kind]);
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-testid={`legal-${kind}-page`}>
      <p className="eyebrow">Legendary Vacational Club</p>
      <h1 className="mt-4 font-display text-4xl sm:text-5xl text-[#0B192C]">{doc.title}</h1>
      <p className="mt-3 text-sm text-slate-500">{doc.updated}</p>
      <div className="mt-10 space-y-10">
        {doc.sections.map((s) => (
          <section key={s.id} id={s.id} className="scroll-mt-28" data-testid={`legal-section-${s.id}`}>
            <h2 className="font-display text-2xl text-[#0B192C]">{s.title}</h2>
            <div className="mt-3 space-y-3 text-base leading-relaxed text-slate-600">
              {s.paragraphs.map((p, i) => <p key={i}>{p}</p>)}
              {s.bullets && <ul className="list-disc pl-5 space-y-1.5">{s.bullets.map((b, i) => <li key={i}>{b}</li>)}</ul>}
            </div>
          </section>
        ))}
        <section className="rounded-xl bg-slate-50 border border-slate-200 p-6 text-sm text-slate-600">
          <p className="font-semibold text-[#0B192C]">{doc.contactTitle}</p>
          <p className="mt-2 break-words">{CONTACT_EMAIL}</p>
          <p className="mt-1">WhatsApp {WHATSAPP_DISPLAY} · Cancún, Quintana Roo, México</p>
        </section>
      </div>
    </div>
  );
}
